import { useDraggable } from "@dnd-kit/core";
import React from "react";

const Draggable = ({children, id}) => {
  const { attributes, listeners, setNodeRef, transform, ...infos } = useDraggable({
    id: id
  });
  return (
    <div ref={setNodeRef} {...attributes} {...listeners}>
      {children}
    </div>
  )
}

export default Draggable